import {
  styled, rem
} from 'config/stitches.config'

const Button = styled('button', {
  display: 'inline-flex',
  alignItems: 'center',
  columnGap: '$3',
  textDecoration: 'none',
  cursor: 'pointer',
  transition: 'background-color ease-in-out .4s, color ease-in-out .4s, border-color ease-in-out .4s',
  fontSize: '$p2-mobile',
  lineHeight: '$p2-mobile',
  boxSizing: 'border-box',
  '&.no-hover': { cursor: 'auto' },
  variants: {
    size: {
      verySmall: {
        height: '$3',
        // width: '$4',
        minWidth: '$4',
        paddingY: '$1/2',
        paddingX: '$1',
        br: '$small',
        '@md': {
          width: 'auto',
          height: rem(40),
        }
      },
      small: {
        letterSpacing: 0.7,
        paddingY: '$1',
        paddingX: '$2',
        br: '$small'
      },
      big: {
        paddingY: '$2',
        paddingX: '$3',
        br: '$big'
      },
      huge: {
        paddingY: '$2',
        paddingX: '$3',
        justifyContent: 'center',
        width: '100%',
        fontSize: '$cta-primary',
        lineHeight: '$cta-primary',
        br: '$huge',
        '@middle': {
          fontSize: '$big-cta-desk',
          lineHeight: '$big-cta-desk',
        }
      },

    },
    theme: {
      default: {
        border: '1px solid $primary',
        backgroundColor: '$primary',
        color: '$white',
        '@md': { '&:not(.no-hover):hover': { backgroundColor: '$black', }, }

      },
      inverted: {
        '&:not(.no-hover)': { border: '1px solid $primary', },
        backgroundColor: '$white',
        color: '$primary',
        '@md': {
          '&:not(.no-hover):hover': {
            backgroundColor: '$primary',
            color: '$white'
          },
        }
      },
      secondary: {
        border: '1px solid $secondary',
        backgroundColor: '$secondary',
        color: '$black',
        '@md': {
          '&:not(.no-hover):hover': {
            borderColor: '$primary',
            backgroundColor: '$primary',
            color: '$white'
          },
        }
      },
      reset: {
        backgroundColor: 'transparent',
        border: 'none',
        br: 0,
        padding: 0,
      },
      noBackground: {
        border: '1px solid $primary',
        backgroundColor: 'transparent',
        color: '$primary',
      },

    },
    disabled: {
      true: { pointerEvents: 'none' },
      false: { pointerEvents: 'auto' }
    }
  },
  defaultVariants: {
    theme: 'default',
    size: 'small'
  }

})

export default Button
